// extracted by mini-css-extract-plugin
module.exports = {"NAV_BAR_HEIGHT":"60px","SIDE_BAR_WIDTH":"325px","COLOR_PRIMARY":"#ff79a0"};